<template>
  <div class="bb-list">
    <div class="bb-list-header">
      <template v-if="type === 3">
        <div class="bb-list-header__title">{{placeholder}}</div>
      </template>
      <template v-else>
        <div
          :class="[
            'bb-list-header-container',
            !vendorPage && 'bb-list-header-container_default'
          ]"
        >
          <input
            :class="[
              'bb-input',
              'bb-input_border',
              vendorPage && 'bb-list-header-container__input',
              !vendorPage && 'bb-list-header__input',
              errorTags && 'bb-input_error'
             ]"
            type="text"
            :placeholder="placeholder"
            v-model="body.name"
            @keyup.enter="createItem()"
          >
          <transition name="fade">
            <div
              v-if="errorTags"
              :class="[
                'bb-list-header-container__icon-error',
                !vendorPage && 'bb-list-header-container__icon-error_default'
              ]"
              @mouseenter="onMouseenterInput(true, $event)"
              @mouseleave="isShowPopupInfoInput = false"
            >
              <span v-html="ExclamationIcon()"/>
            </div>
          </transition>
          <HashTag v-if="vendorPage" class="bb-list-header-container__icon"/>
        </div>
        <button class="bb-subsection-header__btn-add bb-button" @click="createItem()">
          ADD
        </button>
      </template>
    </div>
    <vue-perfect-scrollbar class="bb-subsection-list">
      <div class="bb-list-body">
        <div
          v-if="item.id !== 'all'"
          class="bb-subsection-list-item"
          :class="{'bb-subsection-list-item_active': toolbarIndex === index}"
          v-for="(item, index) in listSort"
          :key="item.id"
          @mouseenter="onMouseEnterRow(index)"
          @mouseleave="onMouseLeave"
        >
          <div
            v-if="editIndex !== index && errorTagsEl !== index"
            class="bb-list-body-item__title"
            :class="{'bb-list-body-item__title_disabled': item.assetCount === 0 }"
            :style="{color: `rgba(${item.color}, 1)`}"
          >
            {{item.name}}
            <span
              v-if="item.assetCount === 0 || item.isUsed"
              class="bb-list-body-item__icon"
              v-html="ExclamationIcon()"
              @mouseenter="onMouseenter(isShowPopupInfo = item.id, $event)"
              @mouseleave="isShowPopupInfo = false"
            />
            <transition name="bounce">
              <div
                v-if="isShowPopupInfo === item.id"
                class="bb-list-body-item__popup"
                :style="positionPopup"
              >
                Unfortunately, it cannot be deleted, since there is linked equipment in this category
              </div>
            </transition>
          </div>
          <input
            v-if="editIndex === index || errorTagsEl === index"
            class="bb-subsection-list-item__input bb-list-body-item__input-edit"
            :class="[errorTagsEl === index && 'bb-input_error']"
            v-autofocus
            v-model="editBody.name"
            @keyup.esc="hideEdit()"
            @keyup.enter="editItem(editBody, index, item.id)"
            v-click-outside="hideEdit"
          >
          <transition name="fade-form">
            <button
              v-if="editIndex === index || errorTagsEl === index"
              class="bb-list-body-item__btn-save bb-button"
              @click="editItem(editBody, index, item.id)"
            >
              SAVE
            </button>
          </transition>
          <transition name="fade-el">
            <SubsectionListColor
              v-if="isColorPicker && toolbarIndex === index"
              :item="item"
              :index="index"
              @onOpenColorPicker="onOpenColorPicker"
            />
          </transition>
          <transition name="fade-el">
            <Toolbar v-if="toolbarIndex === index"
                     :delete-index="deleteConfirmIndex"
                     :index="index"
                     :item="item"
                     :hideEditButton="hideEditButton"
                     :no-delete="cancelDelete(item)"
                     :no-edit="cancelEdit(item)"
                     @deleteOpen="deleteOpen(index)"
                     @deleteClose="deleteConfirmClose()"
                     @openEdit="editFormOpen"
                     @deleteItem="deleteItem"
                     :top="index === list.length-1 && list.length > 1"/>
          </transition>
        </div>
      </div>
    </vue-perfect-scrollbar>
    <transition name="bounce">
      <PopupInfoTags
        v-if="isShowPopupInfoInput"
        :position="positionPopup"
        :description="descriptionErrorPopup"
      />
    </transition>
    <transition name="bounce">
      <BBColorPicker
        v-if="isShowColorPicker"
        :popupPosition="colorPickerPopupPosition"
        :defaultColor="currentItem.color"
        :isShowColorPicker.sync="isShowColorPicker"
        @onChangeActiveColor="onChangeActiveColor"
      />
    </transition>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import HashTag from '@/components/Main/Icons/HashTag'
import _ from 'lodash'
import {ExclamationIcon} from '@/constants/icon'
import PopupInfoTags from '@/components/Settings/Tags/PopupInfoTags/PopupInfoTags'
import SubsectionListColor from '@/components/Settings/Services/SubsectionList/SubsectionListColor'
import BBColorPicker from '@/components/Main/BBColorPicker/BBColorPicker'

export default {
  name: 'SubsectionList',
  props: [
    'list',
    'placeholder',
    'api',
    'type',
    'sortOff',
    'vendorPage',
    'hideEditButton',
    'isError',
    'isErrorEl',
    'descriptionErrorPopup',
    'isColorPicker'
  ],
  components: {
    PopupInfoTags,
    VuePerfectScrollbar,
    Toolbar,
    HashTag,
    SubsectionListColor,
    BBColorPicker
  },
  data () {
    return {
      error: false,
      toolbarIndex: false,
      deleteConfirmIndex: false,
      editIndex: false,
      listSort: [],
      body: {
        name: ''
      },
      editBody: {
        name: ''
      },
      isShowPopupInfo: false,
      isShowPopupInfoInput: false,
      positionPopup: {},
      ExclamationIcon,
      isShowColorPicker: false,
      colorPickerPopupPosition: {},
      currentItem: {}
    }
  },
  computed: {
    errorTags: {
      get () {
        return this.isError
      },
      set (data) {
        this.$emit('update:isError', data)
      }
    },
    errorTagsEl: {
      get () {
        return this.isErrorEl
      },
      set (data) {
        this.$emit('update:isErrorEl', data)
      }
    }
  },
  methods: {
    onMouseEnterRow (index) {
      if (this.isShowColorPicker) return
      this.toolbarIndex = index
    },
    onMouseLeave () {
      if (this.isShowColorPicker) return
      this.toolbarIndex = false
      this.deleteConfirmIndex = false
    },
    onChangeActiveColor (key) {
      const { index, ...all } = this.currentItem
      all.color = key
      this.$emit('changeColor', all, index)
      this.isShowColorPicker = false
    },
    onOpenColorPicker (item, { target }) {
      const { innerHeight } = window
      const { top, left, height } = target.getBoundingClientRect()
      const colorPickerWidth = 198
      const colorPickerHeight = 138
      const topDynamic = innerHeight < top + colorPickerHeight + height ? top - colorPickerHeight : top + height

      this.colorPickerPopupPosition = {
        position: 'fixed',
        left: `${left - colorPickerWidth}px`,
        top: `${topDynamic}px`
      }
      this.isShowColorPicker = !this.isShowColorPicker
      this.currentItem = item
    },
    onMouseenter (value, e) {
      const position = e.target.getBoundingClientRect()
      const { top, left } = position
      this.positionPopup = {
        position: 'fixed',
        top: `${top - 45}px`,
        left: `${left - 120}px`,
        right: 'auto'
      }
      this.isShowPopupInfo = value
    },
    onMouseenterInput (value, e) {
      const position = e.target.getBoundingClientRect()
      const { top, left } = position
      this.positionPopup = {
        position: 'fixed',
        top: `${top - 39}px`,
        left: `${left - 6}px`,
        right: 'auto'
      }
      this.isShowPopupInfoInput = value
    },
    hideEdit () {
      this.editIndex = false
    },
    editFormOpen (index) {
      this.isShowColorPicker = false
      this.errorTags = false
      this.editIndex = index
      this.editBody.name = this.listSort[index].name
    },
    deleteOpen (index) {
      this.isShowColorPicker = false
      this.deleteConfirmIndex = index
    },
    deleteConfirmClose () {
      this.deleteConfirmIndex = false
    },
    createItem () {
      if (!this.body.name) {
        this.error = true
        return
      } else {
        this.error = false
      }
      if (this.type) {
        this.body.type = this.type
      }
      this.$emit('create', this.body)
    },
    editItem (item, index, id) {
      item.id = id
      this.$emit('edit', item, index)
      this.hideEdit()
    },
    deleteItem (index, id) {
      this.deleteConfirmIndex = false
      this.$emit('delete', index, id)
    },
    cancelEdit (item) {
      const { isClient, isCache, type, isBB, isPayroll, assetCount } = item
      return isClient || isCache || type === 3 || isBB || isPayroll || assetCount === 0
    },
    cancelDelete (item) {
      const { isClient, isCache, type, isBB, isPayroll, assetCount, isUsed } = item
      return isClient || isCache || type === 3 || isBB || isPayroll || assetCount === 0 || isUsed
    }
  },
  watch: {
    'body.name' () {
      if (!this.errorTags) return
      this.errorTags = false
    },
    'editBody.name' () {
      if (this.errorTagsEl !== -1) {
        this.editIndex = this.errorTagsEl
      }
      this.errorTagsEl = -1
    },
    list () {
      if (!this.sortOff) {
        this.listSort = _.sortBy(this.list, elem => elem.name)
      } else {
        this.listSort = this.list
      }
    }
  },
  beforeMount () {
    if (!this.sortOff) {
      this.listSort = _.sortBy(this.list, elem => elem.name)
    } else {
      this.listSort = this.list
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-subsection {

    &-header {
      &__btn-add {
        min-width: 73px;
      }
    }

    &-list {
      position: relative;
      padding: 0 4px 0;
      margin-top: 38px;
      font-size: 14px;
      line-height: 17px;
      height: 306px;
      min-width: 340px;

      &__wrapper {
        background-color: $color-white;
        border-radius: 5px;
      }

      &-item {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 51px;
        width: 100%;
        font-size: 14px;
        line-height: 21px;
        cursor: pointer;
        border-bottom: 1px solid transparent;
        border-top: 1px solid $color-wild-sand;
        border-radius: 5px;
        position: relative;

        &__input {
          width: 40%;
        }

        &_active {
          padding-left: 24px;
          padding-right: 24px;
          margin-right: -4px;
          margin-left: -4px;
          position: relative;
          box-shadow: 0 0 12px rgba($color-black, .15);
          border-radius: 5px;
          width: calc(100% + 8px);
          background-color: $color-white;
          border-top: 1px solid transparent;

          & + div {
            border-top: 1px solid transparent;
          }

          &:after {
            content: '';
            position: absolute;
            top: -1px;
            left: 0;
            width: 4px;
            height: calc(100% + 2px);
            background-color: $color-accent;
            border-radius: 4px 0 0 4px;
            z-index: 2;
          }
        }
      }
    }
  }

  .bb-list-header-container {

    &__icon-error {
      position: absolute;
      right: 15px;
      color: $color-pomegranate;
      cursor: pointer;

      &_default {
        right: 37px;
      }
    }
  }

</style>

<style lang="scss">
@import "../../../../sass/variables";

  .bb-list-header-container__icon-error svg {
    width: 14px;
    height: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/Services/SubsectionList/SubsectionList.vue